const sliceString = (str: string, maxLength: number = 12) => {
  if (str.length <= maxLength) return str
  return `${str.slice(0, maxLength)}...`
}

export const mapStrArrToOpts = (arr: string[]) => {
  return arr.map(str => ({
    label: String(str).charAt(0).toUpperCase() + String(str).slice(1).toLowerCase().replace('_', ' '),
    value: str,
  }))
}

export const mapStrArrToTokenTypeOpts = (arr: string[]) => {
  return arr.map(str => {
    const formattedStr = str.replace(/(\D)(\d+)/, '$1-$2').toUpperCase()
    return {
      label: formattedStr,
      value: str,
    }
  })
}

export const mapStrArrToOptsTitle = (arr: string[]) => {
  return arr.map(str => ({
    label: str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' '),
    value: str,
  }))
}

export const formatFilterValues = (values: string[]) => {
  if (values.length === 0) return null
  return values.map(value => sliceString(value)).join(', ')
}
